import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';
import {Application} from '../Application';

export default class MyAccountAPIService extends APIServiceBase {
    constructor() {
        super(Application.getInstance().getOptions().isDalkia() ? 'Dalkia' : 'Cetetherm')
    }

    getPrivacy() {
        return this.get(`Privacy`)

    }
}

registerAPIService(MyAccountAPIService)